'use client'

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import ChatLayout from "@/components/common/chat/chat";

export default function FloatChat({showChat, setShowChat}: {
    showChat: boolean
    setShowChat: Function
}) {

    return (
        <FloatDialog
            show={showChat}
            setShow={setShowChat}
            className="chat-float"
        >
            <FloatDialog.Body>
                <ChatLayout />
            </FloatDialog.Body>
        </FloatDialog>
    )
}